(() => {
  const selector = '.rte--indented-images';

  function updateImage(image) {
    if (!(image instanceof HTMLImageElement)) return;
    const container = image.closest(selector);
    if (!container) return;

    // Match the existing CSS rules; preserve manually styled and floated images.
    const style = image.getAttribute('style');
    if (style !== null && style !== 'float: none;') return;
    if (!image.complete || !image.naturalWidth) return;

    const containerWidth = parseFloat(getComputedStyle(container).width);
    const imageWidth = parseFloat(getComputedStyle(image).width);
    if (!(containerWidth > 0) || !(imageWidth > 0)) return;
    image.classList.toggle('rte__no-indent', imageWidth < containerWidth);
  }

  function updateImages(root = document) {
    root.querySelectorAll(`${selector} img`).forEach(updateImage);
  }

  // Capture native image loads, including lazy images and images in reloaded sections.
  document.addEventListener('load', event => updateImage(event.target), true);
  document.addEventListener('lazyloaded', event => updateImage(event.target));
  document.addEventListener('shopify:section:load', event => updateImages(event.target));

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateImages, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updateImages(), { once: true });
  } else {
    updateImages();
  }
})();
